// 1. O Enum para usar na lógica do código (Ifs, tipagens, etc)
export enum CountStatus {
  InProgress = 1,
  Answered = 4,
  Closed = 5,
  Canceled = 6,
  Grouped = 10,
  Processing = 11,
}

// 2. O Array para montar o HTML (Selects, Checkboxes)
export const CountStatusOptions = [
  { value: CountStatus.InProgress, label: 'Em andamento' },
  { value: CountStatus.Answered, label: 'Atendida' },
  { value: CountStatus.Closed, label: 'Encerrada' },
  { value: CountStatus.Canceled, label: 'Cancelada' },
  { value: CountStatus.Grouped, label: 'Agrupada' },
  { value: CountStatus.Processing, label: 'Em processamento' },
];

// 3. O Dicionário (Record) para traduzir o número para texto numa Tabela
export const CountStatusLabel: Record<CountStatus, string> = {
  [CountStatus.InProgress]: 'Em andamento',
  [CountStatus.Answered]: 'Atendida',
  [CountStatus.Closed]: 'Encerrada',
  [CountStatus.Canceled]: 'Cancelada',
  [CountStatus.Grouped]: 'Agrupada',
  [CountStatus.Processing]: 'Em processamento',
};
